module.exports = __webpack_public_path__ + "static/img/db.965ef5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/db.png
// module id = 5VCK
// module chunks = 3